import Head from 'next/head';
import { Fragment } from 'react';
import { PageData } from '../Page';

type Props = {
  articleStructuredData?: PageData['articleStructuredData'];
  description?: string;
  openGraphImageUrl?: string;
  openToSearchEngines?: boolean;
  title?: string;
};

export const Meta = ({
  articleStructuredData,
  description,
  openGraphImageUrl,
  openToSearchEngines = false,
  title,
}: Props) => {
  return (
    <Head>
      {title && (
        <Fragment>
          <title>{title}</title>
          <meta content={title} property="og:title" />
          <meta content={title} name="twitter:title" />
        </Fragment>
      )}

      {description && (
        <Fragment>
          <meta
            content={description}
            id="meta-description"
            name="description"
          />
          <meta content={description} property="og:description" />
          <meta content={description} name="twitter:description" />
        </Fragment>
      )}

      {openGraphImageUrl && (
        <Fragment>
          <meta content={openGraphImageUrl} property="og:image" />
          <meta content={openGraphImageUrl} name="twitter:image" />
          <meta content="summary_large_image" name="twitter:card" />
        </Fragment>
      )}

      {!openToSearchEngines && (
        <meta content="noindex, nofollow" name="robots" />
      )}

      <meta content="width=device-width, initial-scale=1.0" name="viewport" />

      {articleStructuredData && (
        <script
          type="application/ld+json"
          key="article-structured-data"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Article',
              ...(articleStructuredData.headline && {
                headline: articleStructuredData.headline,
              }),
              ...(articleStructuredData.author && {
                author: {
                  '@type': 'Person',
                  name: articleStructuredData.author,
                },
              }),
              ...(articleStructuredData.dateModified && {
                dateModified: new Date(
                  articleStructuredData.dateModified,
                ).toISOString(),
              }),
              ...(articleStructuredData.datePublished && {
                datePublished: new Date(
                  articleStructuredData.datePublished,
                ).toISOString(),
              }),
              ...(openGraphImageUrl && {
                image: openGraphImageUrl,
              }),
            }),
          }}
        />
      )}
    </Head>
  );
};
